import { Component, Inject, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { eTypeResult } from 'src/app/models/common/enumModel';
import { ISolicitudExtenderModel } from 'src/app/models/interfaces/solicitud/ISolicitudExtenderModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { SolicitudService } from 'src/app/services/solicitud/solicitud.service';

@Component({
  selector: 'app-solicitud-extender',
  templateUrl: './solicitud-extender.component.html',
  styleUrls: ['./solicitud-extender.component.css']
})
export class SolicitudExtenderComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<SolicitudExtenderComponent>,
    private solicitudService: SolicitudService,
    private alertDialogService: AlertDialogService,
    @Inject(MAT_DIALOG_DATA) public model: ISolicitudExtenderModel
  ) { }

  ngOnInit(): void {
  }

  onSubmit(form: NgForm) {
    this.solicitudService.extender(this.model).subscribe((result : ActionResultModel) => {
      if(result.type!=eTypeResult.SUCCESS){
        this.alertDialogService.open(result.message);
      }    
      else{  
        this.alertDialogService.open('Se actualizó la fecha de fin de trabajo de la solicitud');
      }
    });
  }

  onNoClick(){
    this.dialogRef.close();
  }
}
